import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { VideoBackground } from "./components/VideoBackground";
import Helmet from "react-helmet";
import BoxAnimation from "./animations/BoxAnimation";

const gaScript = `
  window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  gtag('js', new Date());
  gtag('config', 'G-43G7M5QJYN');
`;

const gtmScript = `
  (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
  new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
  j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
  'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
  })(window,document,'script','dataLayer','GTM-539WPDKF');
`;

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <Helmet>
      <title>Kamil Wojciak CV</title>
      <script
        async
        src="https://www.googletagmanager.com/gtag/js?id=G-43G7M5QJYN"
      ></script>
      <script>{gaScript}</script>
      <script>{gtmScript}</script>
    </Helmet>
    <BoxAnimation>
      <App />
    </BoxAnimation>
    <VideoBackground />
  </React.StrictMode>
);
